import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { AAdditionalColumns } from '../../../../atoms/additionalColumns';
import Dropdown from '../../../../components_v2/dropdown/Dropdown';
import { setLocalStorage } from '../../../../helpers/localStorage';
import { Translate } from '../../../../styles/global/translate';
import { durationToSeconds, SimpleDurationPicker } from '../createEventFromLasso';
import { BlueTextA, ConstraintType, ModalCalendarH4, ModalCalendarP, ModalCalendarSettingsDescriptionAndDropdown, OPTIMIZATION_RIGHT_PANEL_WIDTH_WITHOUT_PADDING } from '../ModalCalendar';
import { ConstraintProps } from './constraints';

const key = 'VisitDuration';
type Key = typeof key;

export default function VisitDurationConstraint(props: ConstraintProps) {
	const additionalColumns = useRecoilValue(AAdditionalColumns);
	const [constraints, setConstraints] = props.constraintsHook;
	const settings = constraints.get(key) as ConstraintType[Key]['settings'];
	const defaultConstraint = props.defaultConstraints[key];
	const datalist = additionalColumns.filter(c => c.type === 'Integer').map(ac => ({
		value: ac.id,
		label: ac.name,
		checked: settings.field_id === ac.id
	}));
	const selectedValue = datalist.find(c => c.checked);

	return <>
		<ModalCalendarH4>{defaultConstraint.label}</ModalCalendarH4>
		<ModalCalendarSettingsDescriptionAndDropdown>
			<ModalCalendarP><Translate id='visit_duration_description' /></ModalCalendarP>
			<SimpleDurationPicker duration={settings.default} setTimeOperator={(newDuration) => setConstraints(c => {
				setLocalStorage(key + '_default', durationToSeconds({ ...settings.default, ...newDuration }) / 60);
				c.set(key, { ...settings, default: { ...settings.default, ...newDuration } });
				return new Map(c);
			})} />
		</ModalCalendarSettingsDescriptionAndDropdown>
		<ModalCalendarSettingsDescriptionAndDropdown>
			{selectedValue ? <ModalCalendarP><Translate id='visit_duration_description_2' /></ModalCalendarP> : undefined}
			<Dropdown
				cancellable
				dropdownStyle={{
					optionWidth: `${OPTIMIZATION_RIGHT_PANEL_WIDTH_WITHOUT_PADDING}px`,
					optionHeight: '260px',
					width: '100%',
					containerWidth: '100%',
					optionBlockHeight: '34px'
				}}
				datalist={datalist}
				selectedValue={selectedValue}
				name={'visite_duration_dropdown'}
				id='random-id-123'
				key='random-id-123'
				JSXButton={selectedValue ? undefined : () => <BlueTextA><Translate id='visit_duration_description_3' /></BlueTextA>}
				onChange={value => setConstraints(c => {
					setLocalStorage(key + '_field_id', value.value);
					c.set(key, { ...settings, field_id: value.value });
					return new Map(c);
				})}
			/>
		</ModalCalendarSettingsDescriptionAndDropdown>
	</>;
}
